import React from "react";

const STATUS_MAP = {
  active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  suspect: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  suspended: "bg-rose-500/15 text-rose-300 border-rose-500/40",
};

const STATUS_LABELS = { active: "Actif", suspect: "Suspect", suspended: "Suspendu" };

export const AdminStatusPill = ({ s }) => (
  <span
    className={`px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.2em] border ${
      STATUS_MAP[s] || "bg-zinc-800 text-zinc-300 border-zinc-700"
    }`}
  >
    {STATUS_LABELS[s] || s}
  </span>
);

export const adminFmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
  } catch (_e) {
    return iso;
  }
};

export const AdminSectionHeading = ({ icon: Icon, label, count }) => (
  <div className="flex items-center justify-between border-b border-zinc-800 pb-2 mb-2">
    <div className="flex items-center gap-2 text-zinc-300">
      {Icon && <Icon className="w-4 h-4 text-emerald-400" strokeWidth={2.4} />}
      <span className="text-[10px] font-bold uppercase tracking-[0.3em]">{label}</span>
    </div>
    <span className="font-mono text-[10px] text-zinc-500 tabular-nums">
      <span className="text-emerald-300 font-bold">{count}</span> ITEM{count === 1 ? "" : "S"}
    </span>
  </div>
);
